import { useInfiniteQuery } from "@tanstack/react-query";
import { apiFetch } from "./client";

export type PrimeAuthor = "human" | "agent" | "tool" | "system";

export interface PrimeStreamItem {
  id: string;
  called_at: string;
  session_id: string | null;
  channel: string;
  role: string;
  message_type: string;
  author: PrimeAuthor;
  payload: unknown;
}

export interface PrimeStreamPage {
  items: PrimeStreamItem[];
  nextCursor: string | null;
}

export interface PrimeStreamFilters {
  sessionId?: string;
  since?: string;
  until?: string;
  limit?: number;
}

function buildQuery(filters: PrimeStreamFilters, cursor?: string): string {
  const params = new URLSearchParams();
  if (filters.sessionId) params.set("session_id", filters.sessionId);
  if (filters.since) params.set("since", filters.since);
  if (filters.until) params.set("until", filters.until);
  if (filters.limit) params.set("limit", String(filters.limit));
  if (cursor) params.set("cursor", cursor);
  const qs = params.toString();
  return qs ? `?${qs}` : "";
}

export function usePrimeStream(filters: PrimeStreamFilters) {
  return useInfiniteQuery<PrimeStreamPage>({
    queryKey: ["prime-stream", filters],
    initialPageParam: undefined,
    queryFn: async ({ pageParam }) =>
      apiFetch<PrimeStreamPage>(
        `/api/dev/prime-stream${buildQuery(filters, pageParam as string | undefined)}`
      ),
    getNextPageParam: (last) => last.nextCursor ?? undefined,
  });
}
